// import React, { useContext } from "react";
// import styles from "./MaflamImageOffer.module.css";
// import { AboutusPageContext } from "../../store/AboutUsPageContext";

// const MaflamImageOffer = () => {
//   const { aboutusScreenDetails, loading, error } =
//     useContext(AboutusPageContext);

//   if (loading) return <p>Loading...</p>; // Handle loading state
//   if (error) return <p>Error loading data</p>; // Handle error state

//   // Ensure that the API data exists before rendering
//   const maflamOffersTitle = aboutusScreenDetails?.maflamOffersTitle || {
//     title: "What Maflam Offers",
//     description:
//       "Together, we can discover and empower the new generation of filmmakers",
//   };

//   const aboutUsDetailsSec5 = aboutusScreenDetails?.aboutUsDetailsSec5 || [];

//   return (
//     <div className={styles.offersContainer}>
//       <div className={styles.offersHeader}>
//         {/* <p>{maflamOffersTitle.description}</p> */}
//         <h2 style={{ fontSize: "36px" }}>{maflamOffersTitle.title}</h2>
//         <p style={{ fontSize: "16px" }}>{maflamOffersTitle.description}</p>
//       </div>

//       <div className={styles.offersGrid}>
//         {aboutUsDetailsSec5.map((offer, index) => (
//           <div className={styles.offerCard} key={index}>
//             <img
//               src={offer.imageUrl}
//               alt={offer.title}
//               className={styles.offerImage}
//             />
//             <div className={styles.offerTitle}>
//               {/* <p style={{ fontSize: "28px", width: "201px" }}>{offer.title}</p> */}
//               <p>{offer.title}</p>
//             </div>
//           </div>
//         ))}
//       </div>
//     </div>
//   );
// };

// export default MaflamImageOffer;

import React, { useContext } from "react";
import styles from "./MaflamImageOffer.module.css";
import { AboutusPageContext } from "../../store/AboutUsPageContext";
import image from "../../assets/ClubPrograms.jpeg";
import image1 from "../../assets/Consulting.jpeg";
import image2 from "../../assets/CuratedEvents.jpg";
import { LanguageContext } from "../../Component/LanguageContext/LanguageContext";

const MaflamImageOffer = () => {
  const { aboutusScreenDetails, loading, error } =
    useContext(AboutusPageContext);
  const { direction } = useContext(LanguageContext);

  if (loading) return <p>Loading...</p>;
  if (error) return <p>Error loading data</p>;

  const maflamOffersTitle = aboutusScreenDetails?.maflamOffersTitle || {
    title: "What Maflam Offers",
    description:
      "Together, we can discover and empower the new generation of filmmakers",
  };

  const aboutUsDetailsSec5 = aboutusScreenDetails?.aboutUsDetailsSec5 || [];
  const frontendOffers = [
    {
      imageUrl: image,
      titleEng: "Filmmaking Club Programs",
      titleArb: "برنامج نادي صناعة الأفلام",
    },
    {
      imageUrl: image1,
      titleEng: "Consulting",
      titleArb: "استشارات فنية",
    },
    {
      imageUrl: image2,
      titleEng: "Curated Events",
      titleArb: "فعاليات مميزة",
    },
  ];

  const allOffers = [...aboutUsDetailsSec5, ...frontendOffers];

  return (
    <div className={styles.offersContainer}>
      <div className={styles.offersHeader}>
        <h2 style={{ fontSize: "36px" }}>{maflamOffersTitle.title}</h2>
        <p style={{ fontSize: "16px" }}>{maflamOffersTitle.description}</p>
      </div>

      <div className={styles.offersGrid}>
        {allOffers.map((offer, index) => (
          <div className={styles.offerCard} key={index}>
            {/* <img
              src={offer.imageUrl}
              alt={offer.title}
              className={styles.offerImage}
            /> */}
            <div
              className={styles.offerImage}
              style={{
                background: `linear-gradient(1deg, #091D2C 0.52%, rgba(3, 11, 17, 0.00) 47.81%), url(${offer.imageUrl})`,
                backgroundSize: "cover",
                backgroundPosition: "center",
                backgroundRepeat: "no-repeat",
              }}
            />
            <div className={styles.offerTitle}>
              {/* <p>{offer.title}</p> */}
              <p>
                {offer.title ||
                  (direction === "rtl" ? offer.titleArb : offer.titleEng)}
              </p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default MaflamImageOffer;
